export default function parseMenuData(menus) {
  const codeMap = {}
  return {
    menus: parsePages(menus, 0),
    codeMap
  }

  function parsePages(pages, level) {
    level += 1
    return (pages || []).map(page => {
      const pageMenu = {
        id: page.id,
        name: page.resName,
        code: page.permissionCode,
        path: formatPath(page.href),
        level
      }
      if (page.specialPerm) {
        parseAction(page.specialPerm)
      }
      if (page.child) {
        pageMenu.children = parsePages(page.child, level)
      }
      addToMap(pageMenu)
      return pageMenu
    })
  }

  function parseAction(actions) {
    return (actions || []).map(item => {
      const action = { name: item.resName, code: item.permissionCode }
      addToMap(action)
      return action
    })
  }

  function formatPath(url) {
    if (!url) {
      return
    }
    url = url.trim()
    if (url.startsWith('http')) {
      return url
    }
    return url.startsWith('#') ? url.slice(1) : url
  }

  function addToMap(item) {
    if (!item.code) {
      return
    }
    codeMap[item.code] = 1
  }
}
